import { useState } from 'react'
import { Link, Navigate, useSearchParams } from 'react-router-dom'

import { useMe, useRegister } from '../../hooks/queries'

export function RegisterPage() {
  const me = useMe()
  const register = useRegister()
  const [params] = useSearchParams()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [displayName, setDisplayName] = useState('')
  const [inviteCode, setInviteCode] = useState(params.get('code') ?? '')

  // Wer angemeldet ist, hat hier nichts verloren -- mit Einladungscode aber
  // auch nicht in der Chatliste: die Einladungsseite weiß, ob es direkt in
  // die Reise geht oder ob noch eine Bestätigung aussteht. Diese Weiche
  // greift auch gleich nach dem Anlegen des Kontos, sobald `me` steht.
  if (me.data) {
    const ziel = inviteCode.trim()
    return <Navigate to={ziel ? `/join/${ziel}` : '/'} replace />
  }

  return (
    <div className="centered">
      <form
        className="card"
        onSubmit={(event) => {
          event.preventDefault()
          // Wohin es danach geht, entscheidet die Weiche oben -- sie greift,
          // sobald das Konto steht.
          register.mutate({
            email,
            password,
            display_name: displayName,
            invite_code: inviteCode.trim() || undefined,
          })
        }}
      >
        <h1>Konto anlegen</h1>
        <p className="card__lead">
          Der Name steht später über deinen Nachrichten.
        </p>

        {register.isError && <p className="notice">{register.error.message}</p>}

        <label className="field">
          <span className="field__label">Name</span>
          <input
            className="field__input"
            autoComplete="name"
            required
            maxLength={80}
            value={displayName}
            onChange={(event) => setDisplayName(event.target.value)}
          />
        </label>

        <label className="field">
          <span className="field__label">E-Mail-Adresse</span>
          <input
            className="field__input"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </label>

        <label className="field">
          <span className="field__label">Passwort</span>
          <input
            className="field__input"
            type="password"
            autoComplete="new-password"
            required
            minLength={10}
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </label>

        <label className="field">
          <span className="field__label">Einladungscode</span>
          <input
            className="field__input"
            autoCapitalize="characters"
            spellCheck={false}
            placeholder="z. B. K7M2QRXD"
            value={inviteCode}
            onChange={(event) => setInviteCode(event.target.value)}
          />
        </label>

        <button className="button" type="submit" disabled={register.isPending}>
          {register.isPending ? 'Einen Moment …' : 'Konto anlegen'}
        </button>

        <p style={{ marginTop: 18, textAlign: 'center', fontSize: 14 }}>
          Schon ein Konto? <Link to="/login">Anmelden</Link>
        </p>
      </form>
    </div>
  )
}
